<template>
  <div class="df" style="flex-wrap: wrap">
    <template v-for="(item, index) in processProblemDetails" :key="index">
      <div v-if="item.data.length > 0">
        <h2 class="statistics">{{ getProcessName(item.process) }}</h2>

        <template
          v-for="(process, processIndex) in item.data"
          :key="processIndex"
        >
          <template v-for="(details, key) in process" :key="key">
            <table border="1" class="rate-table process-problem-details">
              <tr>
                <th colspan="4">{{ key }}</th>
              </tr>

              <tr>
                <th class="number">序号</th>
                <th>问题点</th>
                <th class="count">发现次数</th>
              </tr>

              <template
                v-for="(problemDetails, problemIndex) in details"
                :key="problemIndex"
              >
                <tr>
                  <td class="number">
                    {{ problemIndex + 1 }}
                  </td>
                  <td class="problem">
                    {{ problemDetails.problem }}
                  </td>
                  <td class="count">
                    {{ problemDetails.frequency }}
                  </td>
                </tr>
              </template>

              <tr>
                <td>{{ details.length + 1 }}</td>
                <td>合计</td>
                <td>
                  {{
                    details.reduce((pre, cur) => {
                      return pre + cur.frequency;
                    }, 0)
                  }}
                </td>
                <td></td>
              </tr>
            </table>
          </template>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import {
  PQCProductOption,
  getProcessName,
} from "@/views/productDaily/serve/option";

export default defineComponent({
  props: {
    unQualifiedData: Object,
  },
  setup(props, context) {
    // 工序问题明细
    const processProblemDetails = reactive([]);

    // 默认设置工序
    const initProcess = () => {
      processProblemDetails.length = 0;
      PQCProductOption.forEach((item) => {
        processProblemDetails.push({
          process: item.value,
          data: [],
        });
      });
    };

    const setProcessData = (data) => {
      Object.keys(data).forEach((key) => {
        const processIndex = processProblemDetails.findIndex(
          (f) => f.process === key
        );

        if (processIndex !== -1) {
          processProblemDetails[processIndex].data.push(data[key]);
        }
      });
    };

    watch(
      () => props.unQualifiedData,
      (val) => {
        initProcess();
        if (val) {
          setProcessData(val);
        }
      },
      {
        immediate: true,
      }
    );

    return {
      getProcessName,
      processProblemDetails,
    };
  },
});
</script>

<style lang="less" scoped>
.statistics {
  margin-top: 20px;
  margin-bottom: 10px;
}
.rate-table > tr > th {
  width: 120px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  text-align: center;
}

.rate-table > tr > :nth-child(odd) {
  background: #e0e0e0;
}

.rate-table {
  margin-right: 20px;
  .number {
    width: 60px !important;
  }
  .problem {
    width: 180px;
  }
  .count {
    width: 80px;
  }
}
</style>
